import React from "react";
import { BaseLayout, DocumentHead } from "./src/features/rootLayout";
import "focus-visible/dist/focus-visible";

import CombinedContextProvider from "./src/context/CombinedContextProvider";
import { PageContextProvider } from "./src/context/PageContext";

export const wrapRootElement = ({ element }) => {
  return <CombinedContextProvider>{element}</CombinedContextProvider>;
};

export const wrapPageElement = ({ props, element }) => {
  return (
    <PageContextProvider value={{ pageContext: props.pageContext }}>
      <DocumentHead />
      <BaseLayout {...props}>{element}</BaseLayout>
    </PageContextProvider>
  );
};

export const onRenderBody = ({ setHeadComponents }) => {
  // Besucherzaehlung mit Plausible (ohne Cookies, kein Banner noetig).
  // Ersetzt TinyAnalytics, dessen alte Einbindung seit 2024 nicht mehr zaehlt.
  setHeadComponents([
    <script
      key="plausible"
      async
      src="https://plausible.io/js/pa-e7CoUZ2tsa0Arfo7TG18j.js"
    ></script>,
    <script
      key="plausible-init"
      dangerouslySetInnerHTML={{
        __html:
          "window.plausible=window.plausible||function(){(plausible.q=plausible.q||[]).push(arguments)},plausible.init=plausible.init||function(i){plausible.o=i||{}};plausible.init()",
      }}
    />,
  ]);
};
